
export function About() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="about" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-[#4A7C2C]/10 px-4 py-2 rounded-full mb-6">
              <span className="text-[#2D5016] font-semibold text-sm">About Us</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Family-Owned Landscaping Excellence Since Day One
            </h2>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              At <strong>Greener Eco Landscaping LLC</strong>, we're a family-owned business dedicated to transforming outdoor spaces in Owings Mills, MD. From routine lawn mowing to complete yard restorations, we bring reliability, quality, and care to every project.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Whether you need seasonal cleanups, hardscaping, concrete work, or snow removal, our experienced team treats your property like our own. We're committed to delivering exceptional landscaping services that enhance your home's beauty and value.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="inline-flex items-center justify-center gap-2 bg-[#4A7C2C] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2D5016] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Request a Quote
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
